import React from 'react'
import { Layout } from '../../Layout'
import { PagePasswordChange } from '../../organisms'
import { Box, Colors } from '../../atoms'
import { RouteComponentProps } from 'react-router'
import { SP_MAX_WIDTH } from '../../../setting'
import { useMediaQuery } from 'react-responsive'

export interface PasswordChangeProps extends RouteComponentProps {
  name?: string
}

export const PasswordChange = (_: PasswordChangeProps) => {
  const isSp = useMediaQuery({
    query: `(max-device-width: ${SP_MAX_WIDTH})`
  })
  return (
    <Layout>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
        backgroundColor={isSp ? 'white' : Colors.bg.default}
      >
        <PagePasswordChange />
      </Box>
    </Layout>
  )
}
